import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {signOut} from '../../reducers/user';

import {
  Dimmer,
  Loader
} from 'semantic-ui-react';

class SignOut extends Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  componentWillMount() {
    this.props.signOut();
  }

  render() {
    return (
      <div>
        <Dimmer active inverted>
          <Loader inverted>Kirjaudutaan ulos...</Loader>
        </Dimmer>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  signOut: () => signOut()
}, dispatch)
  
export default connect(
  null, 
  mapDispatchToProps
)(SignOut)


// WEBPACK FOOTER //
// ./src/containers/signout/index.js